import React, { useRef } from 'react';
import { Menu } from 'primereact/menu';
import { MenuDropdownProps, PopupAlignment } from './MenuDropdown.types';

const MenuDropdown: React.FC<MenuDropdownProps> = ({
  menuItems,
  menuDropdownStyle,
  dotsStyle,
}) => {
  const menuRight = useRef<Menu>(null);

  return (
    <div className="w-full">
      <Menu
        unstyled={true}
        model={menuItems}
        popup
        ref={menuRight}
        id="popup_menu_right"
        popupAlignment={PopupAlignment.RIGHT}
        className={`bg-[#232323] w-[132px] rounded-[5.16px] text-white mt-2 p-2 border-none ${menuDropdownStyle}`}
      />

      <div
        onClick={(event) => menuRight.current?.toggle(event)}
        className={`flex justify-center items-center pr-[1px] w-10 h-10 rounded-[50%] cursor-pointer ${dotsStyle}`}
      >
        <span className="pi pi-ellipsis-v  text-primary"></span>
      </div>
    </div>
  );
};

export default MenuDropdown;
